module.exports = __webpack_public_path__ + "img/logo-imobcoin.54ad47a3.svg";